<template>
  <div class="container p-4">
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <div
      class="modal fade"
      id="exampleModalSm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabelSm"
      aria-hidden="true"
    ></div>
    <site-modal ID="shareModal" modalSize="medium" @Closed="closedshareModal">
      <template #header>
        <h6>این مطلب را با دوستان خود به اشتراک بگذارید</h6>
      </template>
      <template #body>
        <div class="input-group input-group-sm mb-3">
          <input
            type="text"
            disabled
            class="form-control"
            aria-label="Copy Url"
            aria-describedby="button-addon2"
            :value="currentUrl"
          />
          <button
            class="btn btn-small btn-outline-primary"
            type="button"
            id="button-addon2"
            @click="copyToClip"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-clipboard-check"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
              <path
                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
              ></path>
              <path
                d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
              ></path>
            </svg>
          </button>
        </div>
        <div class="text-center">
          <a
            href=""
            class="btn btn-sm btn-facebook rounded-circle transition-hover-top"
            rel="noopener"
            onclick="shareOnFacebook(window.location.href)"
            title="Facebook"
          >
            <i class="fi fi-social-facebook m-0"></i>
          </a>
          <a
            href=""
            class="btn btn-sm btn-linkedin rounded-circle transition-hover-top"
            rel="noopener"
            onclick="shareOnLinkedin(window.location.href)"
            title="Linkedin"
          >
            <i class="fi fi-social-linkedin m-0"></i>
          </a>
          <a
            href=""
            class="btn btn-sm btn-twitter rounded-circle transition-hover-top"
            rel="noopener"
            onclick="shareOnTwitter(window.location.href)"
            title="Twitter"
          >
            <i class="fi fi-social-twitter m-0"></i>
          </a>
          <a
            href=""
            class="btn btn-sm btn-twitter rounded-circle transition-hover-top"
            rel="noopener"
            onclick="shareOnTelegram(window.location.href)"
            title="Telegram"
          >
            <i class="fi fi-send m-0"></i>
          </a>
          <a
            href=""
            class="btn btn-sm btn-whatsapp rounded-circle transition-hover-top"
            rel="noopener"
            onclick="shareOnWhatsApp(window.location.href)"
            title="WhatsApp"
          >
            <svg
              width="20px"
              height="20px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-whatsapp pt-4"
              viewBox="0 0 16 16"
              style="margin-left: 0.4rem !important"
            >
              <path
                d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
              ></path>
            </svg>
          </a>
          <a
            href=""
            class="btn btn-sm btn-email rounded-circle transition-hover-top"
            rel="noopener"
            onclick="shareOnEmail(window.location.href)"
            title="Email"
          >
            <i class="fi fi-envelope-2 m-0"></i>
          </a>
        </div>
      </template>
      <template #footer>
        <div></div>
      </template>
    </site-modal>
    <div class="article-format p-4 p-lg-4 mx-auto shadow-sm rounded">
      <div class="mb-5 border-bottom">
        <div class="text-muted pb-2 small">
          <h3 class="fw-bolder">
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-question-diamond-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM5.495 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
              ></path>
            </svg>
            پرسش {{ entity.questionNumber }}
          </h3>
          <p class="justified fw-bolder fs-6 text-dark">
            {{ entity.question }}
          </p>
        </div>

        <p class="px-2 small m-1 text-gray-700 text-start">
          <i class="fi fi-calendar"></i>
          {{ getPersianPublishDate(entity.publishDate) }}
        </p>
        <div class="clearfix">
          <p class="fs-4 float-end sticky-kit js-stickified">
            <a
              class="text-secondary"
              title="اشتراک گذاری"
              href="#"
              @click="shareIconClick"
              ><i class="fi fi-share mx-2"></i
            ></a>
            <!-- data-bs-toggle="modal"
              data-bs-target="#exampleModalSm" -->
            <!-- <a
              class="text-secondary"
              title="می پسندم"
              href="#"
              @click="likeIconClick"
              ><i class="fi fi-like mx-2"></i
            ></a> -->
          </p>
          <div class="float-start">
            <a
              href="#!"
              class="text-dark bg-light small rounded py-2 px-3 m-1 text-decoration-none d-inline-block"
              rel="nofollow"
              v-for="item in subjectTitles"
              :key="item"
            >
              {{ item }}
            </a>
          </div>
        </div>
      </div>
      <div class="text-muted border-bottom pb-2 small mt-2">
        <h3 class="fw-bolder">
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-reply-fill"
            viewBox="0 0 16 16"
          >
            <path
              d="M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"
            ></path>
          </svg>
          پاسخ
        </h3>
      </div>
      <div
        ref="answerBox"
        class="justified mt-2 prevent-select"
        v-html="entity.answer"
      ></div>

      <div>
        <a
          href="#!"
          class="text-dark badge rounded-pill bg-primary-soft py-2 px-3 m-1 text-decoration-none d-inline-block"
          rel="nofollow"
          v-for="item in keyWords"
          :key="item"
        >
          {{ item }}
        </a>
      </div>
      <div v-if="relatedArticles.length > 0">
        <p class="text-muted border-bottom pb-2 small mt-5">مقالات مرتبط</p>
        <div class="text-center sectionArticle">
          <carousel
            :settings="settings"
            dir="rtl"
            :breakpoints="breakpoints"
            class="m-0 p-0"
          >
            <slide v-for="item in relatedArticles" :key="item.guid">
              <div class="card border-0 h-100 shadow rounded-xl article-card">
                <div class="card-title">
                  <a :href="'/ArticleView/' + item.guid">
                    <p class="pt-3">
                      {{ getArticleTitle(item.title) }}
                    </p>
                  </a>
                </div>

                <div class="">
                  <a :href="'/ArticleView/' + item.guid"
                    ><img
                      width="350"
                      :alt="item.title + ' ' + item.englishTitle"
                      :src="`${this.$store.state.apiBaseURL}/ST/Article/GetArticleImage?id=${item.id}`"
                  /></a>
                </div>

                <div class="ps-0 pe-0 text-gray-500">
                  <hr class="m-0" />
                  <!-- <div class="clearfix m-0">
                    <a
                      :href="'/ArticleView/' + item.guid"
                      class="text-gray-700 ltr"
                      dir="ltr"
                      >{{ item.englishTitle }}</a
                    >
                    <p class="px-2 smaller text-gray-700">
                      <i class="fi fi-calendar"></i>
                      {{ getPersianPublishDate(item.publishDate) }}
                    </p>
                  </div> -->
                </div>
              </div>
            </slide>

            <template #addons>
              <navigation />
              <pagination />
            </template>
          </carousel>
        </div>
      </div>

      <div v-if="relatedQuestions.length > 0">
        <p class="text-muted border-bottom pb-2 small mt-5">
          پرسش و پاسخ های مرتبط
        </p>

        <div class="text-center">
          <carousel
            :settings="settings"
            dir="rtl"
            :breakpoints="breakpoints"
            class="m-0 p-0"
          >
            <slide
              class="relQuestionItem col-12 col-md-12 col-lg-4"
              v-for="item in relatedQuestions"
              :key="item.guid"
            >
              <div class="w-100 h-100 ms-1">
                <div
                  class="card border-0 bg-white h-100 shadow rounded-xl question-card"
                >
                  <div class="text-center pt-2 pe-2 bg-gray-300">
                    <a :href="'/questionAnswerView/' + item.guid"
                      ><h3 class="fs-5 text-end fw-bold text-gray-800">
                        <!-- <svg
                          width="40px"
                          height="40px"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi bi-question-circle"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                          ></path>
                          <path
                            d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                          ></path>
                        </svg> -->
                        پرسش {{ item.questionNumber }}
                      </h3>
                      <!-- <p class="px-2 smaller text-start m-0 text-gray-700">
                        <i class="fi fi-calendar"></i>
                        {{ getPersianPublishDate(item.publishDate) }}
                      </p> -->
                    </a>
                  </div>

                  <div class="card-body">
                    <a :href="'/questionAnswerView/' + item.guid"
                      ><p class="text-end text-justified text-gray-900">
                        {{ item.questionAbstract }}
                      </p></a
                    >
                  </div>
                </div>
              </div>
            </slide>

            <template #addons>
              <navigation />
              <pagination />
            </template>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useRoute } from 'vue-router';
import axios from 'axios';
import LoadingSpinner from '../../components/utility/loadingSpinner/LoadingSpinner.vue';
import { Modal } from 'bootstrap';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import { isMobile } from 'mobile-device-detect';

export default {
  components: {
    LoadingSpinner,
    Carousel,
    Slide,
    Pagination,
    Navigation,
    // SiteModal,
  },
  data() {
    return {
      shareModal: new Object(),
      questionAnswerGUID: null,
      allSubjects: [],
      subjectTitles: [],
      isMobile: isMobile,
      relatedArticles: [],
      relatedQuestions: [],
      currentUrl: '',
      settings: {
        itemsToShow: 1,
        snapAlign: 'start',
      },
      breakpoints: {
        // 700px and up

        700: {
          itemsToShow: 1,
          snapAlign: 'center',
        },
        // 1024 and up
        1024: {
          itemsToShow: 2,
          snapAlign: 'start',
        },
        1200: {
          itemsToShow: 3,
          snapAlign: 'start',
        },
      },
      entity: {
        id: 0,
        guid: '',
        title: '',
        englishTitle: '',
        subjectIDs: [],
        content: '',
        publishDate: '',
        abstract: '',
        keyWord: '',
      },
    };
  },
  methods: {
    async getQuestionAnswer() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get(
          `/ST/QuestionAnswer/GetQuestionAnswerByGUID/${that.questionAnswerGUID}`
        )
        .then((response) => {
          that.entity = response.data;
          that.keyWords = that.entity.keyword
            .split('#')
            .filter((f) => f != '')
            .map((m) => '#' + m);
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت داده با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async getRelatedArticles() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get(`/ST/QuestionAnswer/GetRelatedArticles/${that.questionAnswerGUID}`)
        .then((response) => {
          that.relatedArticles = response.data;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت داده با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    getArticleTitle(title) {
      if (isMobile) {
        if (title.length > 22) {
          return title.substr(0, 19) + '...';
        }
      } else {
        if (title.length > 40) {
          return title.substr(0, 40) + '...';
        }
      }

      return title;
    },

    async getRelatedQuestions() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get(
          `/ST/QuestionAnswer/GetRelatedQuestions/${that.questionAnswerGUID}`
        )
        .then((response) => {
          that.relatedQuestions = response.data;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت داده با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    getPersianPublishDate(date) {
      /* eslint-disable */
      return new persianDate(new Date(date)).format('LLLLL');
    },
    async getAllSubjects() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get('/ST/Subject/GetAllSubjects')
        .then((response) => {
          that.allSubjects = response.data;
          // this.$refs.spinner.hide();
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async getSubjectNames() {
      this.subjectTitles = [];
      this.entity.subjectIDs.forEach((f) => {
        this.subjectTitles.push(
          this.allSubjects.find((ff) => ff.id === f)?.title
        );
      });
    },
    shareIconClick() {
      this.shareModal.show();
    },
    closedshareModal() {
      this.shareModal.hide();
    },
    // likeIconClick() {},
    copyToClip() {
      copyToClipboard(this.currentUrl);
      this.$refs.notification.show({
        type: 'success',
        title: `کپی شد`,
      });
    },
  },
  async mounted() {
    try {
      this.$refs.spinner.show();
      const route = useRoute();
      let that = this;
      that.currentUrl = window.location.href;
      that.questionAnswerGUID = route.params.id;
      await that.getQuestionAnswer();
      await that.getAllSubjects();
      await that.getSubjectNames();
      await that.getRelatedArticles();
      await that.getRelatedQuestions();
      this.shareModal = new Modal(document.getElementById('shareModal'), {
        keyboard: false,
      });
    } finally {
      this.$refs.spinner.hide();
    }

    this.$refs.answerBox.addEventListener('contextmenu', function (e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  },
};
</script>
<!-- <style scoped>
.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
</style> -->
<style>
p {
  overflow-wrap: break-word !important;
}
img {
  max-width: 100%;
}
</style>
